module.exports = __webpack_public_path__ + "static/desktop/img/typeset-mobile-photobook.6d370d1f.png";